"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCollectionStoreProps } from "./QZUWIJQN.js";
import { useStore, useStoreProps } from "./CTKPPFRS.js";
import { useEvent } from "./HNHAUIIY.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/form/form-store.ts
import * as Core from "@ariakit/core/form/form-store";
import { useCallback, useEffect, useMemo } from "react";
function useFormStoreProps(store, update, props) {
  store = useCollectionStoreProps(store, update, props);
  useStoreProps(store, props, "values", "setValues");
  useStoreProps(store, props, "errors", "setErrors");
  useStoreProps(store, props, "touched", "setTouched");
  var useValue = useCallback(function (name) {
    return store.useState(function () {
      return store.getValue(name);
    });
  }, [store]);
  var useValidate = useCallback(function (callback) {
    callback = useEvent(callback);
    var items = store.useState("items");
    useEffect(function () {
      return store.onValidate(callback);
    }, [items, callback]);
  }, [store]);
  var useSubmit = useCallback(function (callback) {
    callback = useEvent(callback);
    var items = store.useState("items");
    useEffect(function () {
      return store.onSubmit(callback);
    }, [items, callback]);
  }, [store]);
  return useMemo(function () {
    return __spreadProps(__spreadValues({}, store), {
      useValue: useValue,
      useValidate: useValidate,
      useSubmit: useSubmit
    });
  }, []);
}
function useFormStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useStore = useStore(Core.createFormStore, props),
    _useStore2 = _slicedToArray(_useStore, 2),
    store = _useStore2[0],
    update = _useStore2[1];
  return useFormStoreProps(store, update, props);
}
export { useFormStoreProps, useFormStore };